import React, { useEffect, useState } from 'react';
import { meetingService } from '../../services/meetingService';
import { formatFirstSessionDate } from '../../services/workshop2026Service';
import { formatWorkshopRosterMessage } from '../../utils/workshopRosterText';
import { Meeting } from '../../services/meetingService';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopCommunitySectionProps {
  meetingCode: string;
  meeting: Meeting | null;
  showPhoneList: boolean;
  onRosterCountChange?: (count: number) => void;
}

const WorkshopCommunitySection: React.FC<WorkshopCommunitySectionProps> = ({
  meetingCode,
  meeting,
  showPhoneList,
  onRosterCountChange,
}) => {
  const [rosterNames, setRosterNames] = useState<string[]>([]);
  const [namesHiddenCount, setNamesHiddenCount] = useState(0);
  const [confirmedCount, setConfirmedCount] = useState(0);
  const [workshopStarted, setWorkshopStarted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const firstSession = formatFirstSessionDate(meeting);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const roster = await meetingService.getWorkshopRoster(meetingCode);
        if (cancelled) return;
        const names = roster.names.map((n) => n.display_name).filter(Boolean);
        setRosterNames(names);
        setNamesHiddenCount(roster.names_hidden_count ?? 0);
        setConfirmedCount(roster.confirmed_count ?? names.length);
        setWorkshopStarted(roster.workshop_started);
        onRosterCountChange?.(roster.confirmed_count ?? names.length);
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Could not load participant info');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [meetingCode, onRosterCountChange]);

  if (loading) return <p className={styles.helperText}>Loading…</p>;
  if (error) return <p className={styles.helperText}>{error}</p>;

  const rosterMessage = formatWorkshopRosterMessage(
    rosterNames,
    namesHiddenCount,
    confirmedCount,
    workshopStarted
  );

  return (
    <>
      {!showPhoneList && (
        <>
          <p className={rosterNames.length > 0 ? styles.rosterNames : styles.helperText}>
            {rosterMessage}
          </p>

          <p className={styles.helperText}>
            Phone and email lists will be available to confirmed members when the workshop starts
            {firstSession !== 'date TBD' ? ` (${firstSession})` : ''}. You can opt in under
            preferences.
          </p>
        </>
      )}
    </>
  );
};

export default WorkshopCommunitySection;
